import { Routes } from '@angular/router';

export const myFavoritesRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./my-favorites.page').then((m) => m.MyFavoritesPage),
  },
];
